import script from "./InvisibleSelectorWidget.vue?vue&type=script&lang=js"
export * from "./InvisibleSelectorWidget.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__